import i18next from '@/i18n';

// Мост между AngularJS-шаблонами и react-i18next: {{ 'ключ' | translate }}.
// Использует тот же экземпляр i18next, что и React-компоненты (переключатель языка
// в HeaderContent меняет его глобально через i18next.changeLanguage). Помечен как
// $stateful, поскольку перевод может появиться асинхронно (после загрузки
// translations/<lng>/translation.json бэкендом i18next-http-backend) или смениться
// в любой момент — обычный "чистый" фильтр Angular не переоценивался бы при этом.
angular.module('shbdeployer.app').filter('translate', function () {
  function translateFilter(key, options) {
    if (!key) {
      return key;
    }
    return i18next.t(key, options); /* i18next-extract-disable-line */
  }
  translateFilter.$stateful = true;
  return translateFilter;
});
